import toast from "react-hot-toast";
import { LiaTimesSolid } from "react-icons/lia";
import PropTypes from "prop-types";
import { useDeleteFaqMutation } from "../../../features/api/faqApiSlice";

const DelFaqConfirmation = ({ faq, setConfirmationOpen }) => {
  const [deleteFaq] = useDeleteFaqMutation();

  const handleDelete = async () => {
    try {
      const response = await deleteFaq({ id: faq?._id });
      // Check if the response is successful
      setConfirmationOpen(false);
      if (response?.data) {
        toast.success(response.data.message);
      } else {
        throw new Error("Unexpected response format");
      }
    } catch (error) {
      toast.error(error?.data?.message || "Failed to delete faq.");
    }
  };

  return (
    <div className="confirmation-modal">
      <div className="confirmation-wrapper animateModal" role="dialog">
        <button
          aria-label="close-dialog"
          className="close-dialog-btn"
          onClick={() => setConfirmationOpen(false)}
        >
          {<LiaTimesSolid aria-hidden="true" />}
        </button>
        <h3>Are you sure you want to delete: {faq?.question}?</h3>
        <div className="confirmation-buttons">
          <button
            className="cancel-button"
            onClick={() => setConfirmationOpen(false)}
          >
            Cancel
          </button>
          <button className="delete-button" onClick={handleDelete}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

DelFaqConfirmation.propTypes = {
  // handleAppointmentDeletion: PropTypes.func.isRequired,
  faq: PropTypes.object.isRequired,
  setConfirmationOpen: PropTypes.func.isRequired,
};

export default DelFaqConfirmation;
